import React from 'react';
import { useSEO } from '../hooks/useSEO';
import Navbar from './Navbar';
import Footer from './Footer';
import Container from './Container';

const TermsPage = () => {
  useSEO({
    title: 'Όροι και Προϋποθέσεις - TailClinic',
    description: 'Διαβάστε τους Όρους και τις Προϋποθέσεις χρήσης της πλατφόρμας TailClinic. Ενημερωθείτε για τα δικαιώματα και τις υποχρεώσεις σας.',
    canonical: 'https://www.tailclinic.gr/terms',
  });

  return (
    <div style={{ backgroundColor: '#1A202C', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />

      <main style={{ padding: '6rem 0', position: 'relative', overflow: 'hidden', flex: 1 }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(800px 800px at 10% -10%, rgba(16,185,129,0.12), transparent), radial-gradient(800px 800px at 110% 10%, rgba(59,130,246,0.06), transparent)' }} />
        
        <Container>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '4rem', position: 'relative' }}>
            <div style={{
              display: 'inline-block',
              padding: '0.35rem 1rem',
              borderRadius: '9999px',
              fontSize: '0.85rem',
              fontWeight: 700,
              color: '#10B981',
              backgroundColor: 'rgba(16,185,129,0.1)',
              border: '1px solid rgba(16,185,129,0.2)',
              marginBottom: '1.5rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em'
            }}>
              ΝΟΜΙΚΑ
            </div>
            <h1 style={{
              fontSize: '3rem',
              fontWeight: '800',
              color: 'white',
              marginBottom: '1.25rem',
              letterSpacing: '-0.02em'
            }}>
              Όροι και Προϋποθέσεις
            </h1>
            <p style={{
              fontSize: '1.15rem',
              color: '#9CA3AF',
              maxWidth: '800px',
              margin: '0 auto',
              lineHeight: '1.6'
            }}>
              Οι παρόντες όροι διέπουν τη χρήση της υπηρεσίας <span style={{ color: '#10B981', fontWeight: '600' }}>TailClinic</span>. Με την πρόσβαση ή/και χρήση των υπηρεσιών μας, αποδέχεστε πλήρως τους όρους αυτούς.
            </p>
          </div>

          {/* Content Card */}
          <div style={{ 
            background: 'linear-gradient(135deg, rgba(16,185,129,0.25), rgba(59,130,246,0.15))', 
            borderRadius: '1.5rem', 
            padding: '1px',
            maxWidth: '950px',
            margin: '0 auto',
            boxShadow: '0 20px 40px rgba(0,0,0,0.2)'
          }}>
            <div style={{
              backgroundColor: '#1F2937',
              borderRadius: '1.5rem',
              padding: '3rem 4rem'
            }}>
              
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '2.5rem',
                color: '#D1D5DB'
              }}>
                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>1.</span> Γενικά
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Το <span style={{ color: '#10B981', fontWeight: '600' }}>TailClinic</span> είναι πλατφόρμα διαδικτυακής διαχείρισης κτηνιατρικών ραντεβού και πελατών. Οι όροι αυτοί μπορεί να τροποποιηθούν ανά πάσα στιγμή χωρίς προηγούμενη ειδοποίηση. Συνιστάται να ελέγχετε τακτικά την παρούσα σελίδα για τυχόν αλλαγές.
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>2.</span> Παρεχόμενες Πληροφορίες & Υπηρεσίες
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Καταβάλλουμε κάθε δυνατή προσπάθεια για την πληρότητα και εγκυρότητα των πληροφοριών που εμφανίζονται στο TailClinic. Η διαθεσιμότητα ραντεβού, οι ιατρικές διαγνώσεις και οι αλλαγές/ακυρώσεις αποτελούν αποκλειστική ευθύνη της εκάστοτε κλινικής και όχι της πλατφόρμας.
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>3.</span> Περιορισμός Ευθύνης
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Το TailClinic δεν ευθύνεται για τεχνικά προβλήματα που οφείλονται στον εξοπλισμό του χρήστη ή τρίτους παρόχους (π.χ. διακοπές Internet). Παρέχουμε την υπηρεσία "ως έχει" (as is) και σε καμία περίπτωση δεν φέρουμε ευθύνη για έμμεσες, επακόλουθες ή αποθετικές ζημίες, ούτε για ζητήματα ιατρικής αμέλειας.
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>4.</span> Λογαριασμοί & Ασφάλεια
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Είστε υπεύθυνοι για την ακρίβεια των στοιχείων σας και τη διατήρηση της εμπιστευτικότητας των κωδικών πρόσβασής σας. Εφαρμόζουμε σύγχρονα μέτρα ασφαλείας, ωστόσο η προστασία του λογαριασμού σας από μη εξουσιοδοτημένη πρόσβαση βαραίνει και εσάς.
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>5.</span> Χρήση της Υπηρεσίας
                  </h2>
                  <ul style={{ paddingLeft: '1.5rem', lineHeight: 1.8, fontSize: '1.05rem', margin: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <li>Απαγορεύεται η καταχρηστική χρήση, η παρεμβολή στη λειτουργία ή η προσπάθεια μη εξουσιοδοτημένης πρόσβασης.</li>
                    <li>Οι κλινικές είναι αποκλειστικά υπεύθυνες για τα ιατρικά δεδομένα και τις πληροφορίες που καταχωρούν.</li>
                    <li>Διατηρούμε το δικαίωμα αναστολής πρόσβασης σε περίπτωση παραβίασης των όρων.</li>
                  </ul>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>6.</span> Συνδρομές & Πληρωμές
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Οι χρεώσεις, ο κύκλος τιμολόγησης και οι φόροι καθορίζονται ανάλογα με το επιλεγμένο πλάνο. Οι πληρωμές διενεργούνται με ασφάλεια μέσω πιστοποιημένων τρίτων παρόχων (Stripe). Σε περίπτωση αναβάθμισης, η χρέωση γίνεται αναλογικά, ενώ σε περίπτωση υποβάθμισης ισχύει από τον επόμενο κύκλο χρέωσης.
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>7.</span> Προστασία Δεδομένων (GDPR)
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Η επεξεργασία δεδομένων διενεργείται σύμφωνα με την Πολιτική Απορρήτου μας και τον Γενικό Κανονισμό Προστασίας Δεδομένων (GDPR). Οι κλινικές φέρουν την αποκλειστική ιδιότητα του "Υπεύθυνου Επεξεργασίας" (Data Controller) για τα ιατρικά δεδομένα των πελατών τους, ενώ το TailClinic δρα ως "Εκτελών την Επεξεργασία" (Data Processor).
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>8.</span> Διαχείριση Δεδομένων & Τερματισμός
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Σε περίπτωση παύσης συνεργασίας με το TailClinic, η κλινική έχει το δικαίωμα να ζητήσει την <strong>οριστική διαγραφή όλων των δεδομένων της</strong>. Προς το παρόν, η πλατφόρμα δεν υποστηρίζει τη μαζική εξαγωγή (export) δεδομένων σε εξωτερικά αρχεία. Το TailClinic δεν φέρει καμία ευθύνη για την επικοινωνία της παύσης αυτής προς τους πελάτες της κλινικής.
                  </p>
                </section>

                <section>
                  <h2 style={{ fontSize: '1.4rem', fontWeight: '700', color: 'white', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color: '#10B981' }}>9.</span> Εφαρμοστέο Δίκαιο
                  </h2>
                  <p style={{ lineHeight: 1.8, fontSize: '1.05rem' }}>
                    Οι παρόντες όροι διέπονται από το Ελληνικό Δίκαιο. Αρμόδια για κάθε αναφυόμενη διαφορά είναι τα δικαστήρια της έδρας της εταιρείας μας.
                  </p>
                </section>

                {/* Footer of the card */}
                <div style={{ 
                  marginTop: '1rem', 
                  paddingTop: '2rem', 
                  borderTop: '1px solid #374151', 
                  display: 'flex', 
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '1rem'
                }}>
                  <div style={{ fontSize: '0.9rem', color: '#9CA3AF' }}>
                    Τελευταία ενημέρωση: <strong>Φεβρουάριος 2026</strong>
                  </div>
                  <div style={{ fontSize: '0.9rem', color: '#9CA3AF' }}>
                    Έχετε απορίες; <a href="mailto:support@tailclinic.gr" style={{ color: '#10B981', textDecoration: 'none', fontWeight: '600' }}>support@tailclinic.gr</a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </Container>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage;